import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { useToast } from "../../../../shared/hooks";
import { IAgreementInstallment, SinisterAgreementService } from "../../../../shared/services/api/sinister/SinisterAgreementService";

interface Props {
	open: boolean;
	agreementId: string;
	installment: IAgreementInstallment;
	onClose: () => void;
}

// Mostra os campos crus retornados pelo backend — o formato do payload de segunda-via
// ainda não tem um contrato fechado, então evitamos assumir nomes de campo específicos aqui.
export const ModalSegundaVia = ({ open, agreementId, installment, onClose }: Props) => {
	const toastHandler = useToast();
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<Record<string, unknown> | null>(null);

	useEffect(() => {
		if (!open) {
			setData(null);
			return;
		}

		(async () => {
			setIsLoading(true);
			const result = await SinisterAgreementService.getSegundaVia(agreementId, installment.number);
			setIsLoading(false);

			if (result instanceof Error) {
				toastHandler.present({ type: "error", messageOrContent: result.message, position: "top-right" });
				onClose();
				return;
			}

			setData(result);
		})();
	}, [open, agreementId, installment.number]);

	return (
		<>
			<LoadingComp isopen={isLoading} />
			<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
				<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
						2ª Via — Parcela {installment.number}
					</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon fontSize="small" />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Stack spacing={1} mt={0.5}>
						{!isLoading && data && Object.keys(data).length === 0 && (
							<Typography variant="body2" color="text.secondary">
								O Sicoob não retornou dados adicionais para essa parcela.
							</Typography>
						)}
						{data &&
							Object.entries(data).map(([key, value]) => (
								<Box key={key} display="flex" justifyContent="space-between" gap={2}>
									<Typography variant="body2" color="text.secondary">
										{key}
									</Typography>
									<Typography variant="body2" fontWeight={500} sx={{ textAlign: "right", wordBreak: "break-word" }}>
										{typeof value === "object" ? JSON.stringify(value) : String(value)}
									</Typography>
								</Box>
							))}
					</Stack>
				</DialogContent>

				<DialogActions>
					<Button onClick={onClose}>Fechar</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
